module.exports = __webpack_public_path__ + "static/media/left-web.3bf244eb.svg";